import AppStore from '@v4/store/appStore'
import { useSectionMetaData } from '@v4/components/common/SectionItem'
import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { useRef } from 'react'
import useStyles from './Header.styled'
import { LINK_TYPE } from './Header.const'

export const useHeader = () => {
	const metaData = useSectionMetaData()
	const basename = AppStore.useStoreState(state => state.general.basename)
	const classes = useStyles({ metaData })
	const sortHandlerParentRef = useRef()

	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.path })
	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	return [
		{
			classes,
			text: metaData.text?.metaValue,
			textConfig: metaData.text?.config,
			alignment: metaData.alignment?.metaValue,
			direction: metaData.alignment?.contentDirection(),
			href: metaData.linkType?.metaValue === LINK_TYPE.CUSTOM ? metaData.link.metaValue : basename || '/',
			image: metaData.path,
			withImage: !!metaData.path?.image,
			isCentered: metaData.alignment?.isCenterAlignment,
			textAlignment: metaData.alignment?.textAlignment,
			textEditable,
			textKey: metaData.text?.tierKey,
			sortHandlerParentRef,
		},
		{ handleImageClick, handleTextClick, handleTextChange },
	]
}
